import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService, AppConfigService } from '@alfresco/adf-core';

/** A row in the menu_item table, as edited by the Menu Manager. */
export interface MenuAdminItem {
  id?: number | null;
  menuKey: string;
  label: string;
  icon: string;
  route: string | null;
  parentId: number | null;
  sortOrder: number;
  color: string | null;
  requiredRole: string | null;
  licenseTier: string;            // CORE | STANDARD | PREMIUM | CUSTOM:<key>
  isActive: boolean;
  menuType: string;               // HEADER | SIDEBAR_CATEGORY | SIDEBAR_ITEM
  workflowType: string | null;    // CONTRACT | MAIL | INVOICE | null
}

/** CRUD client for the admin Menu Manager (backend /bpm/api/menu/admin, SKYPLUS_ADMIN-gated). */
@Injectable({ providedIn: 'root' })
export class SkyplusMenuAdminService {
  private readonly base: string;

  constructor(
    private http: HttpClient,
    private auth: AuthenticationService,
    appConfig: AppConfigService
  ) {
    const apiBase = appConfig.get<string>('skyplus.apiUrl', '/bpm/api');
    this.base = `${apiBase}/menu/admin`;
  }

  list(): Observable<MenuAdminItem[]> {
    return this.http.get<MenuAdminItem[]>(`${this.base}/items`, { headers: this.headers() });
  }

  create(item: MenuAdminItem): Observable<MenuAdminItem> {
    return this.http.post<MenuAdminItem>(`${this.base}/items`, item, { headers: this.headers('application/json') });
  }

  update(id: number, item: MenuAdminItem): Observable<MenuAdminItem> {
    return this.http.put<MenuAdminItem>(`${this.base}/items/${id}`, item, { headers: this.headers('application/json') });
  }

  remove(id: number): Observable<unknown> {
    return this.http.delete(`${this.base}/items/${id}`, { headers: this.headers() });
  }

  private headers(contentType?: string): HttpHeaders {
    let h = new HttpHeaders();
    try {
      const t = this.auth.getToken();
      if (t) { h = h.set('Authorization', `Bearer ${t}`); }
    } catch { /* no token */ }
    if (contentType) { h = h.set('Content-Type', contentType); }
    return h;
  }
}
